import { render } from "./AssignIncentivesTable.vue?vue&type=template&id=694619a2"
import script from "./AssignIncentivesTable.vue?vue&type=script&lang=js"
export * from "./AssignIncentivesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__